"use client";

import { useEffect } from "react";

const copyIcon = `
<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff" style="vertical-align:middle;"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M17.5 14H19C20.1046 14 21 13.1046 21 12V5C21 3.89543 20.1046 3 19 3H12C10.8954 3 10 3.89543 10 5V6.5M5 10H12C13.1046 10 14 10.8954 14 12V19C14 20.1046 13.1046 21 12 21H5C3.89543 21 3 20.1046 3 19V12C3 10.8954 3.89543 10 5 10Z" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
`;

const copiedIcon = `
<svg width="16" height="16" viewBox="0 0 24 24" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff" style="vertical-align:middle;"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M20.6097 5.20743C21.0475 5.54416 21.1294 6.17201 20.7926 6.60976L10.7926 19.6098C10.6172 19.8378 10.352 19.9793 10.0648 19.9979C9.77765 20.0166 9.49637 19.9106 9.29289 19.7072L4.29289 14.7072C3.90237 14.3166 3.90237 13.6835 4.29289 13.2929C4.68342 12.9024 5.31658 12.9024 5.70711 13.2929L9.90178 17.4876L19.2074 5.39034C19.5441 4.95258 20.172 4.87069 20.6097 5.20743Z" fill="#ffffff"></path> </g></svg>  
`;

export default function CodeCopyEnhancer() {
    useEffect(() => {
        const btnHTML = `${copyIcon} <span>Copy Code</span>`;
        const btnCopiedHTML = `${copiedIcon} <span>Copied!</span>`;

        const addButtons = () => {
            document.querySelectorAll("pre").forEach((pre) => {
                if (pre.parentElement?.classList.contains("code-block-wrapper")) return;

                // Wrap <pre> in a div
                const wrapper = document.createElement("div");
                wrapper.className = "code-block-wrapper relative";

                pre.replaceWith(wrapper);
                wrapper.appendChild(pre);

                // Create button
                const btn = document.createElement("button");
                btn.innerHTML = btnHTML;
                btn.className =
                    "flex items-center gap-1 absolute top-2 right-2 px-2 py-1 text-xs bg-gray-800 md:bg-transparent text-white rounded hover:bg-gray-700 transition cursor-pointer";

                wrapper.appendChild(btn);

                btn.addEventListener("click", () => {
                    navigator.clipboard.writeText(pre.innerText);
                    btn.innerHTML = btnCopiedHTML;
                    setTimeout(() => (btn.innerHTML = btnHTML), 1200);
                });
            });
        };

        // Run initially
        addButtons();

        // Observe future changes (because SafeHTML injects content dynamically)
        const observer = new MutationObserver(addButtons);
        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, []);

    return null;
}
